<template>
	<main class="container">
		<h1>Concert de Santes</h1>
		<p>
			Properament
		</p>
	</main>
</template>

<script>
	export default {
		data() {
			return {

			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Santes.vue